import { useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { removeLoader } from '../utils/rest.js';
import { ErrorPage } from './error-page/index.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const Fallback = () => {
  useEffect(() => {
    return () => {
      removeLoader(10);
    };
  }, []);
  return null;
};
const NotFoundPage = () => /*#__PURE__*/jsx(ErrorPage, {
  errorCode: "404"
});
const Routes = _ref => {
  let {
    routes
  } = _ref;
  return /*#__PURE__*/jsxs(Switch, {
    children: [routes.map(page => /*#__PURE__*/jsx(Route, {
      path: page.path,
      component: loadable(page.component, {
        fallback: /*#__PURE__*/jsx(Fallback, {})
      }),
      ...page.options
    }, page.path)), /*#__PURE__*/jsx(Route, {
      path: "*",
      component: NotFoundPage
    }, 404)]
  });
};

export { Routes };
//# sourceMappingURL=router.js.map
